


import { ISelectOption } from "../dtos/SelectOptionDto";
enum BreakReasonCodes {
        Item1 = 0,
        Item2 = 1,
         
}

export class BreakReasonCodes_class {

public static enum = BreakReasonCodes;

  public static readonly enumByText : { [key : string ]: number} = {
    ['Item1']: 0,
    ['Item2']: 1,
    
  };
  public static readonly enumByNumber : { [key : number ]: string} = {
    [0]: "1- Customary break/Holiday",
    [1]: "2- Between academic years",
    
  };

  public static readonly enumAsSelectOptions:Array<ISelectOption<number>> = [
  {value: 0, text: "1- Customary break/Holiday"},
  {value: 1, text: "2- Between academic years"},
  ]
}

